<template>
  <button class="btn btn-info" @click="send">
    <i class="fas fa-paper-plane"></i>
  </button>
</template>
<script>
  export default {
    props: ['reports', 'bus'],

    methods: {
      send() {
        _.each(this.reports, report => {
          if (report.client.invoice_checkbox) {
            this.bus.$emit('send-invoices', report.client.id)
          }
        })
        this.$emit('uncheck')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/financialReports/GlobalSendButton.vue